/* globals Attachments, ErrorHandler */

window.Attachments = {}

function csrfToken () {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

function resolveRoot (selector) {
  if (!selector) return document
  return selector.jquery ? selector[0] : selector
}

Attachments.initDropzone = function (selector, uploadCallback) {
  const root = resolveRoot(selector)

  if (!root.querySelector('form.dropzone-attachments:not(.dz-inited)')) return

  import('dropzone').then(({ default: Dropzone }) => {
    root.querySelectorAll('form.dropzone-attachments:not(.dz-inited)').forEach((form) => {
      // eslint-disable-next-line no-new
      new Dropzone(form, {
        paramName: 'attachment_relation[attachment_attributes][file]',
        maxFilesize: 100,
        previewTemplate: root.querySelector('#preview-template').innerHTML,
        previewsContainer: root.querySelector('#attachments-previews-container'),
        sending: function (file, xhr, formData) {
          formData.append('authenticity_token', csrfToken())
        },
        init: function () {
          let filesNum
          form.classList.add('dz-inited')
          filesNum = 0
          const that = this
          this.on('addedfile', function (file) {
            filesNum++
            const filename = file.previewElement.querySelector('.filename')
            const truncate = filename?.dataset.dzNameTruncate
            if (truncate) {
              filename.textContent = Helpers.truncate(file.name, truncate)
            }
            root.querySelectorAll('.done-link').forEach((el) => { el.style.display = 'none' })
          })
          this.on('complete', function (file) {
            filesNum--
            if (filesNum === 0) {
              root.querySelectorAll('.done-link').forEach((el) => { el.style.display = '' })
            }
          })
          this.on('error', function (file, error) {
            ErrorHandler.alertError(error.error || error, {
              delay: 5000,
              addOn: ' ' + (I18n.t('mailers.attachment_will_be_removed', {
                name: file.name
              }))
            })
            setTimeout(function () {
              file.previewElement.remove()
            }, 5000)
          })
          this.on('success', function (file, data) {
            const previewElement = file.previewElement

            if (data.id) {
              previewElement.id = 'att' + data.uuid
              const links = previewElement.querySelectorAll('.remover, a.filename')
              const url = links[0].getAttribute('href') + '/' + data.uuid
              links.forEach((link) => {
                link.setAttribute('href', url)
                link.style.display = 'inline'
              })

              const select = previewElement.querySelector('select')
              if (select) {
                select.disabled = false
                select.addEventListener('change', function (e) {
                  previewElement.classList.remove('dz-success')
                  fetch(url, {
                    method: 'PUT',
                    headers: {
                      Accept: 'application/json',
                      'X-CSRF-Token': csrfToken(),
                      'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({ 'attachment_relation[attachment_type_id]': e.target.value })
                  }).then((response) => {
                    if (response.ok) {
                      previewElement.classList.remove('dz-success')
                      previewElement.classList.add('dz-saved')
                    }
                  })
                })
              }
            } else {
              previewElement.querySelector('.remover').addEventListener('click', function () {
                that.removeFile(file)
              })
              if (data.error) {
                previewElement.classList.remove('dz-success')
                previewElement.classList.add('dz-error')
                const errorSpan = previewElement.querySelector('.dz-error-mark span')
                if (errorSpan) errorSpan.textContent = data.error
              }
            }
            if (uploadCallback && typeof uploadCallback === 'function') {
              uploadCallback()
            }
          })
        }
      })
    })
  })
}

Attachments.initAvatar = function () {
  const form = document.getElementById('avatar_attachments')
  if (!form || form.classList.contains('dz-inited')) return

  import('dropzone').then(({ default: Dropzone }) => {
    if (form.classList.contains('dz-inited')) return

    // eslint-disable-next-line no-new
    new Dropzone(form, {
      paramName: 'attachment_relation[attachment_attributes][file]',
      maxFilesize: 100,
      acceptedFiles: '.jpeg, .jpg, .png',
      sending: function (file, xhr, formData) {
        formData.append('authenticity_token', csrfToken())
      },
      processing: function () {
        document.getElementById('user_photo')?.classList.add('opacity')
        const preloader = document.getElementById('avatar_preloader')
        if (preloader) preloader.style.display = 'block'
      },
      success: function (file, data) {
        const preloader = document.getElementById('avatar_preloader')
        if (preloader) preloader.style.display = 'none'
        const userPhoto = document.getElementById('user_photo')
        userPhoto?.classList.remove('opacity')
        const img = userPhoto?.querySelector('.photo img')
        if (img) img.src = file.previewElement.querySelector('img').src
      },
      init: function () {
        form.classList.add('dz-inited')
      }
    })

    document.getElementById('user_photo')?.addEventListener('click', function () {
      document.querySelector('.candidate-head .dz-panel.dz-message')?.click()
    })
  })
}

Attachments.init = function (element) {
  Helpers.initHoverDropdowns(element)
  $('.tooltip').remove()

  const elementNode = document.querySelector(element)
  elementNode && window.createTooltips(elementNode.querySelector('[data-bs-toggle="tooltip"]'))
  $('.editable', element).editable({
    error: (error) => console.error('Attachments:', error),
    send: 'always',
    params: function (obj) {
      return { attachment_relation: { [obj.name]: obj.value } }
    },
    ajaxOptions: { type: 'PATCH' }
  })

  // Override display of tags after save
  $('.editable.tags', element).on('save', function (e, params) {
    $(this).one('hidden', () => $(this).html(params.newValue.map(function (tag) { return $('<span class="tag">' + tag + '</span>') })))
  })
}

Attachments.auditableCountdown = function () {
  $('.countdown').each(function () {
    const countdownElement = $(this)
    const date = countdownElement.data('date')
    const url = countdownElement.data('url')
    countdownElement.countdown(date)
      .on('update.countdown', function (event) { $(this).html(event.strftime('%H:%M:%S')) })
      .on('finish.countdown', function (event) { url && setTimeout(function () { $.post(url) }, 1000) })
  })
}

$(document).ready(function () {
  // TODO: move to controllers?
  Attachments.initDropzone()
  Attachments.initAvatar()
})
